import { createReducer } from "@reduxjs/toolkit";

import { updateFeatureFlag } from "./actions";
import type { FeatureFlagState } from "./types";

const initialState = {} as FeatureFlagState;

export const featureFlagReducer = createReducer(initialState, (builder) => {
  builder.addCase(updateFeatureFlag, (_state, action) => {
    return action.payload;
  });
});
